<multi-choice-item *ngIf="view"
                   [view]="view"
                   [class.highlight]="highlight"
                   (onValueChange)="onValueChange($event)"
                   (onReadOnly)="onReadOnly($event)"
                   (onDisabled)="onDisallowed($event)">
</multi-choice-item>
